import React, { Children } from 'react'
import PropTypes from 'prop-types'
// import classnames from 'classnames'

import { Labeled, CardContentInner } from 'react-admin'
import { DatasheetField } from '../Fields'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { DependantsInstalationsTree } from '../Generic'
import FTIcon from '@material-ui/icons/Assignment'

const styles = {
    form: {
        margin: '20px'
    },
    button: {
        icon: {
            marginRight: '10px'
        }
    },
    title : {
        padding: '0 0 20px 20px',
        borderBottom: '1px solid #B5B5B7',
        alignItems: 'center',
        color : '#64676C',
        fontSize : 25,
        fontWeight: 600,
        '& svg' : {
            color : '#33C2D5',
            paddingRight : 10,
            fontSize: 18,
        }
    },
    subTitle : {
        marginTop : 30,
        padding: '0 0 20px 20px',
        display: 'flex',
        alignItems: 'center',
        color : '#64676C',
        fontSize : 18,
        fontWeight: 600,
        '& svg' : {
            color : '#33C2D5',
            paddingRight : 10,
            fontSize: 18,
        }
    },
    thead : {
        '& tr th' : {
            color: '#019EAC',
            fontSize: '0.85rem',
            fontWeight: 600,
            borderBottom : 'none',
            backgroundColor : '#EFEEEF',
        }
    },
    tbody : {
        '& tr td' : {
            color : '#676767',
            fontSize: '0.85rem',
        },
        '& tr td:first-child' : {
            fontWeight: 500,
        }
    },
    elementGrid :{
        // marginBottom: 10,
        borderBottom: '4px solid #63CAD4',
        paddingTop: 10,
        paddingBottom: 0,
        paddingRight: 10,
        paddingLeft: 10,
        height: '100%',
    },
    label : {
        color : '#3C3E3F',
        fontWeight: 600,
        textTransform: 'capitalize',
        fontSize: 18,
    },
    value : {
        '& span' : {
            color : '#696B6C'
        }
    }
}


const sanitizeRestProps = ({
    children,
    className,
    record,
    resource,
    basePath,
    version,
    initialValues,
    translate,
    ...rest
}) => rest


export const CustomShowLayout = ({
    basePath,
    classes,
    className,
    children,
    record,
    resource,
    version,
    schema,
    title,
    ...rest
}) => (
    
    <CardContentInner
        className={className}
        key={version}
        {...sanitizeRestProps(rest)}
    >
        <Typography className={classes.title} >
            {title} {record.name}
        </Typography>
        <Typography className={classes.subTitle}><FTIcon/> Registros</Typography>
        <Grid container spacing={24}>
        {Children.map(children, field =>
            field ? (
                <Grid item xs={12} md={4} >
                    <div className={classes.elementGrid}>
                    {field.props.label ? (
                        <Labeled
                            record={record}
                            resource={resource}
                            basePath={basePath}
                            label={field.props.label}
                            source={field.props.source}
                            disabled={false}
                            classes={{label : classes.label, value : classes.value}}
                        >
                            {field}
                        </Labeled>
                    ) : typeof field.type === 'string' ? (
                        field
                    ) : (
                        React.cloneElement(field, {
                            record,
                            resource,
                            basePath,
                        })
                    )}
                    </div>
                </Grid>
            ) : null
        )}
        </Grid>
        {!!schema &&
        <Grid item xs={12} style={{marginTop : 30}} >
            <Typography className={classes.subTitle}><FTIcon/> Ficha Técnica</Typography>
            {React.cloneElement(<DatasheetField schema={schema} />, {
                record,
                resource,
                basePath,
            })}
        </Grid>}
        {!["empresas", "grupos"].includes(resource) &&
        <Grid item xs={12}>
            <DependantsInstalationsTree resource={resource} id={record.id}/>
        </Grid>}
    </CardContentInner>
)

CustomShowLayout.propTypes = {
    basePath: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    record: PropTypes.object,
    resource: PropTypes.string,
    version: PropTypes.number,
}

export default withStyles(styles)(CustomShowLayout)